/**
 * プッシュ通知（Web Push）の varuna エンドポイント クライアント。
 *
 * - `register_push_token/` … このブラウザの宛先を登録（Firebase ID トークン必須。uuid は送らない）
 * - `delete_push_token/` … 宛先を解除（uuid + トークン。ログアウト後にも呼べるよう ID トークン不要）
 * - `open_push_notification/` … 通知の開封を記録（Firebase ID トークン必須）
 *
 * 新規エンドポイントなので本文は JSON（careerconnection-client.ts と同じ作法）。
 */
import axios from 'axios'

const ENDPOINT_PREFIX = process.env.VUE_APP_ENDPOINT_PREFIX || '/'
const TIMEOUT_MS = 15000
/** ログアウト・OFF 操作の後始末なので長く待たない */
const DELETE_TIMEOUT_MS = 5000

const url = (path: string) => `${ENDPOINT_PREFIX}${path}`

const jsonHeaders = (idToken?: string) => ({
  'Content-Type': 'application/json',
  ...(idToken ? { Authorization: `Bearer ${idToken}` } : {})
})

export const registerPushToken = (idToken: string, deviceToken: string) =>
  axios.post(
    url('register_push_token/'),
    { device_token: deviceToken, channel: 'web' },
    { timeout: TIMEOUT_MS, headers: jsonHeaders(idToken) }
  )

export const deletePushToken = (uuid: string, deviceToken: string) =>
  axios.post(
    url('delete_push_token/'),
    { uuid, device_token: deviceToken },
    { timeout: DELETE_TIMEOUT_MS, headers: jsonHeaders() }
  )

export const recordPushOpened = (idToken: string, notificationId: string) =>
  axios.post(
    url('open_push_notification/'),
    { notification_id: notificationId },
    { timeout: TIMEOUT_MS, headers: jsonHeaders(idToken) }
  )
